<template>
  <section id="app-wrapper">
    <router-view />
  </section>
</template>

<script>
export default {
  name: "ErrorLayout",
};
</script>
